
import { useEffect } from "react";
import { isAccessTokenExpired, renewAccessToken } from "./utils";

export function useTokenRenewal(user) {
  useEffect(() => {
    if (user) {
      const accessTokenExpired = isAccessTokenExpired();

      if (accessTokenExpired === true) {
        renewAccessToken();
      }

      const interval = setInterval(() => {
        const accessTokenExpired = isAccessTokenExpired();

        if (accessTokenExpired) {
          renewAccessToken();
        }
      }, 30000);

      return () => clearInterval(interval);
    }
  }, [user]);
}
